import { render, staticRenderFns } from "./RequirementFilter.vue?vue&type=template&id=24a60da1&scoped=true"
import script from "./RequirementFilter.vue?vue&type=script&lang=js"
export * from "./RequirementFilter.vue?vue&type=script&lang=js"
import style0 from "./RequirementFilter.vue?vue&type=style&index=0&id=24a60da1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a60da1",
  null
  
)

export default component.exports